// import { GoldenSourceHelper } from "../../../app/Switch_Core_React_Standards";

/**
 * @constant {string} API_BASE - The root URL for all gateway communication, 
 * sourced from environment variables.
 */
const API_BASE = process.env.REACT_APP_API_BASE_URL || "";

/**
 * Generates the standardized security header block for the NRG Gateway.
 * includes session identifiers, site keys, and Unix timestamps for request signing.
 * * @param {string} siteKey - Unique identifier for the client site.
 * @param {string} intent - The action being performed (e.g., 'Initialize', 'Instructions').
 * @returns {Object} A collection of headers including Bearer token and X-SEC markers.
 */
export const getSecurityHeaders = (siteKey, intent) => ({
  "Content-Type": "application/json",
  "SITE-KEY": siteKey,
  "X-INTENT": intent,
  "Authorization": `Bearer ${sessionStorage.getItem("SEC_SESSION_ID")}`,
  "X-SEC-USER-GUID": sessionStorage.getItem("SEC_USER_GUID"),
  "X-SEC-SESSION-ID": sessionStorage.getItem("SEC_SESSION_ID"),
  "X-TIMESTAMP": Math.floor(Date.now() / 1000).toString(),
});

/**
 * Core wrapper for fetch that implements automatic DTO (Data Transfer Object) 
 * enhancement and security header injection.
 * * @param {string} endpoint - The API path (e.g., /api/v1/batch/...)
 * @param {string} method - HTTP Verb (GET, POST, etc.)
 * @param {string} siteKey - Client site identifier.
 * @param {string} intent - Transaction intent for gateway logging.
 * @param {Object} body - The raw payload data.
 * @throws {Error} Gateway Exception if the response status is not OK.
 */
export const secureFetch = async (endpoint, method, siteKey, intent, body = {}) => {
  // Inject session markers into body for .NET DTO validation logic on the backend.
  // This satisfies the backend requirement for siteUserGuid and sessionID.
  const enhancedBody = method === "POST" ? {
    ...body,
    siteUserGuid: sessionStorage.getItem("SEC_USER_GUID"),
    sessionID: sessionStorage.getItem("SEC_SESSION_ID")
  } : null;

  const response = await fetch(`${API_BASE}${endpoint}`, {
    method,
    headers: getSecurityHeaders(siteKey, intent),
    body: enhancedBody ? JSON.stringify(enhancedBody) : null,
  });

  if (!response.ok) throw new Error(`Gateway Exception: ${response.status}`);
  return await response.json();
};